import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CpfCnpjHidePipe } from "../pipes/cpfCnpjHide.pipe";
import { CpfCnpjPipe } from "../pipes/cpfCnpj.pipe";
import { TelefonePipe } from "../pipes/telefone.pipe";
import { CepPipe } from "../pipes/cep.pipe";
import { CurrencyScalePipe } from "../pipes/currency-scale.pipe";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskDirective,
    NgxMaskPipe,
    DragDropModule,
    CpfCnpjHidePipe,
    CpfCnpjPipe,
    DatePipe,
    TelefonePipe,
    CepPipe,
    CurrencyScalePipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskDirective,
    NgxMaskPipe,
    DragDropModule,
    CpfCnpjHidePipe,
    CpfCnpjPipe,
    DatePipe,
    TelefonePipe,
    CepPipe,
    CurrencyScalePipe
  ],
  providers: [provideNgxMask()]
})
export class SharedModule {
}
